export default Object.freeze([
    'Planning',
    'Signing',
    'Signed',
    'In Progress',
    'Completed',
    'Cancelled',
]);
